import { Row, Col } from "react-bootstrap";
import React, { useState, useContext, useEffect } from "react";
import Rectangle from "./Rectangle/rectangle";


import "../Assets/Css/index.scss";
const CheckoutReview = (props) => {
  const { setupFee, planDescription, planPrice, totalPrice, coupon } = props;
  const messageBoxDisplayClass = !planDescription ? "" : "d-none";
  const [customSetupFee, setCustomSetupFee] = useState(setupFee);
  const [customSubscription, setCustomSubscription] = useState(planPrice);
  const [totalSetupDiscount, setTotalSetupDiscount] = useState(0);
  const [totalSubscriptionDiscount, setTotalSubscriptionDiscount] = useState(0);

  useEffect(() => {
    console.log("COUPON: ", coupon);
    if (coupon) {
      if (coupon.percentageFee) {
        setTotalSetupDiscount((setupFee * coupon.percentageFee / 100));
        setCustomSetupFee(setupFee - (setupFee * coupon.percentageFee / 100));
      }
      if (coupon.valueFee) {
        setTotalSetupDiscount(coupon.valueFee);
        setCustomSetupFee(setupFee - coupon.valueFee);
      }

      if (coupon.percentageSubscription) {
        setTotalSubscriptionDiscount((planPrice * coupon.percentageSubscription / 100));
        setCustomSubscription(planPrice - (planPrice * coupon.percentageSubscription / 100));
      }
      if (coupon.valueSubscription) {
        setTotalSubscriptionDiscount(coupon.valueSubscription);
        setCustomSubscription(planPrice - coupon.valueSubscription);
      }
    }
    else {
      setTotalSetupDiscount(0);
      setCustomSetupFee(setupFee);
      setTotalSubscriptionDiscount(0);
      setCustomSubscription(setupFee);
    }
  }, [coupon]);

  const formatCurrency = (value) => {
    return Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(value);
  };


  return (
    <div className="checkout-review">
      <div className={`message-box ${messageBoxDisplayClass}`}>
        <Rectangle
          className={`button-select-your-plan`}
          title={`Select your plan`}
        />
      </div>
      <h3>Checkout Review</h3>
      <Row>
        <Col className="col-md-10">
          <p className="checkout-item" style={{ paddingLeft: 3 }}>
            <svg fill="none" height="22" viewBox="0 0 16 22" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m8 17h.01m-5.01-16h10c1.1046 0 2 .89543 2 2v16c0 1.1046-.8954 2-2 2h-10c-1.10457 0-2-.8954-2-2v-16c0-1.10457.89543-2 2-2z" stroke="#fbbd05" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /></svg>
            Custom app + On Demand Portal <span>(One time fee)</span>
          </p>
        </Col>
        <Col className="col-md-2">
          <p>
            {totalSetupDiscount > 0 && <><s>{formatCurrency(setupFee)}</s><br /><b>{formatCurrency(customSetupFee)}</b></>}
            {totalSetupDiscount == 0 && <b>{formatCurrency(setupFee)}</b>}
          </p>
        </Col>
      </Row>

      <Row>
        <Col className="col-md-10">
          <p className="checkout-item" >
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.5417 14.4167C13.1295 14.4167 14.4167 13.1295 14.4167 11.5417C14.4167 9.95385 13.1295 8.66667 11.5417 8.66667C9.95385 8.66667 8.66667 9.95385 8.66667 11.5417C8.66667 13.1295 9.95385 14.4167 11.5417 14.4167Z" stroke="#FBBD05" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M18.6333 14.4167C18.5058 14.7057 18.4677 15.0264 18.5241 15.3372C18.5804 15.6481 18.7287 15.935 18.9496 16.1608L19.0071 16.2183C19.1853 16.3963 19.3267 16.6077 19.4231 16.8404C19.5196 17.0731 19.5692 17.3225 19.5692 17.5744C19.5692 17.8263 19.5196 18.0757 19.4231 18.3083C19.3267 18.541 19.1853 18.7524 19.0071 18.9304C18.8291 19.1086 18.6177 19.25 18.385 19.3464C18.1523 19.4429 17.9029 19.4925 17.651 19.4925C17.3992 19.4925 17.1498 19.4429 16.9171 19.3464C16.6844 19.25 16.473 19.1086 16.295 18.9304L16.2375 18.8729C16.0116 18.652 15.7248 18.5038 15.4139 18.4474C15.103 18.391 14.7824 18.4291 14.4933 18.5567C14.2099 18.6781 13.9682 18.8799 13.7979 19.137C13.6276 19.3941 13.5362 19.6954 13.535 20.0037V20.1667C13.535 20.675 13.3331 21.1625 12.9736 21.522C12.6142 21.8814 12.1267 22.0833 11.6183 22.0833C11.11 22.0833 10.6225 21.8814 10.263 21.522C9.9036 21.1625 9.70167 20.675 9.70167 20.1667V20.0804C9.69425 19.7632 9.59157 19.4556 9.40699 19.1975C9.22241 18.9394 8.96445 18.7429 8.66667 18.6333C8.37762 18.5058 8.05698 18.4677 7.7461 18.5241C7.43522 18.5804 7.14836 18.7287 6.9225 18.9496L6.865 19.0071C6.68699 19.1853 6.47561 19.3267 6.24293 19.4231C6.01025 19.5196 5.76084 19.5692 5.50896 19.5692C5.25708 19.5692 5.00767 19.5196 4.77499 19.4231C4.54231 19.3267 4.33092 19.1853 4.15292 19.0071C3.97471 18.8291 3.83334 18.6177 3.73689 18.385C3.64043 18.1523 3.59078 17.9029 3.59078 17.651C3.59078 17.3992 3.64043 17.1498 3.73689 16.9171C3.83334 16.6844 3.97471 16.473 4.15292 16.295L4.21042 16.2375C4.43135 16.0116 4.57955 15.7248 4.63592 15.4139C4.69229 15.103 4.65424 14.7824 4.52667 14.4933C4.40519 14.2099 4.20347 13.9682 3.94636 13.7979C3.68925 13.6276 3.38796 13.5362 3.07958 13.535H2.91667C2.40834 13.535 1.92082 13.3331 1.56138 12.9736C1.20193 12.6142 1 12.1267 1 11.6183C1 11.11 1.20193 10.6225 1.56138 10.263C1.92082 9.9036 2.40834 9.70167 2.91667 9.70167H3.00292C3.32012 9.69425 3.62775 9.59157 3.88583 9.40699C4.1439 9.22241 4.34048 8.96445 4.45 8.66667C4.57757 8.37762 4.61562 8.05698 4.55925 7.7461C4.50289 7.43522 4.35468 7.14836 4.13375 6.9225L4.07625 6.865C3.89805 6.68699 3.75667 6.47561 3.66022 6.24293C3.56376 6.01025 3.51412 5.76084 3.51412 5.50896C3.51412 5.25708 3.56376 5.00767 3.66022 4.77499C3.75667 4.54231 3.89805 4.33092 4.07625 4.15292C4.25426 3.97471 4.46564 3.83334 4.69832 3.73689C4.931 3.64043 5.18041 3.59078 5.43229 3.59078C5.68417 3.59078 5.93358 3.64043 6.16626 3.73689C6.39894 3.83334 6.61033 3.97471 6.78833 4.15292L6.84583 4.21042C7.07169 4.43135 7.35856 4.57955 7.66944 4.63592C7.98031 4.69229 8.30095 4.65424 8.59 4.52667H8.66667C8.95011 4.40519 9.19185 4.20347 9.36212 3.94636C9.5324 3.68925 9.62377 3.38796 9.625 3.07958V2.91667C9.625 2.40834 9.82693 1.92082 10.1864 1.56138C10.5458 1.20193 11.0333 1 11.5417 1C12.05 1 12.5375 1.20193 12.897 1.56138C13.2564 1.92082 13.4583 2.40834 13.4583 2.91667V3.00292C13.4596 3.3113 13.5509 3.61258 13.7212 3.8697C13.8915 4.12681 14.1332 4.32852 14.4167 4.45C14.7057 4.57757 15.0264 4.61562 15.3372 4.55925C15.6481 4.50289 15.935 4.35468 16.1608 4.13375L16.2183 4.07625C16.3963 3.89805 16.6077 3.75667 16.8404 3.66022C17.0731 3.56376 17.3225 3.51412 17.5744 3.51412C17.8263 3.51412 18.0757 3.56376 18.3083 3.66022C18.541 3.75667 18.7524 3.89805 18.9304 4.07625C19.1086 4.25426 19.25 4.46564 19.3464 4.69832C19.4429 4.931 19.4925 5.18041 19.4925 5.43229C19.4925 5.68417 19.4429 5.93358 19.3464 6.16626C19.25 6.39894 19.1086 6.61033 18.9304 6.78833L18.8729 6.84583C18.652 7.07169 18.5038 7.35856 18.4474 7.66944C18.391 7.98031 18.4291 8.30095 18.5567 8.59V8.66667C18.6781 8.95011 18.8799 9.19185 19.137 9.36212C19.3941 9.5324 19.6954 9.62377 20.0037 9.625H20.1667C20.675 9.625 21.1625 9.82693 21.522 10.1864C21.8814 10.5458 22.0833 11.0333 22.0833 11.5417C22.0833 12.05 21.8814 12.5375 21.522 12.897C21.1625 13.2564 20.675 13.4583 20.1667 13.4583H20.0804C19.772 13.4596 19.4707 13.5509 19.2136 13.7212C18.9565 13.8915 18.7548 14.1332 18.6333 14.4167Z" stroke="#FBBD05" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            AWS setup
          </p>
        </Col>
        <Col className="col-md-2">
          <p>
            <b>$0.00</b>
          </p>
        </Col>
      </Row>

      <Row>
        <Col className="col-md-10">
          <p className="checkout-item">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 2.0835H8C6.05003 7.92506 6.05003 14.2419 8 20.0835H7M14 2.0835C15.95 7.92506 15.95 14.2419 14 20.0835M2 15.0835V14.0835C7.84157 16.0335 14.1584 16.0335 20 14.0835V15.0835M2 8.0835C7.84157 6.13353 14.1584 6.13353 20 8.0835M11 21.0835C16.523 21.0835 21 16.6065 21 11.0835C21 5.5605 16.523 1.0835 11 1.0835C5.477 1.0835 1 5.5605 1 11.0835C1 16.6065 5.477 21.0835 11 21.0835Z" stroke="#FBBD05" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Web Widget and On Demand Portal
          </p>
        </Col>
        <Col className="col-md-2">
          <p>
            <b>$0.00</b>
          </p>
        </Col>
      </Row>

      <Row>
        <Col className="col-md-10">
          <p className="checkout-item">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.93 4.0135L7.47 7.5435M3.93 18.1535L7.47 14.6235M18.08 18.1535L14.54 14.6235M18.08 4.0135L14.54 7.5435M11 21.0835C16.523 21.0835 21 16.6065 21 11.0835C21 5.5605 16.523 1.0835 11 1.0835C5.477 1.0835 1 5.5605 1 11.0835C1 16.6065 5.477 21.0835 11 21.0835ZM11.03 15.5835C12.2235 15.5835 13.3681 15.1094 14.212 14.2655C15.0559 13.4216 15.53 12.277 15.53 11.0835C15.53 9.89002 15.0559 8.74543 14.212 7.90152C13.3681 7.0576 12.2235 6.5835 11.03 6.5835C9.83653 6.5835 8.69193 7.0576 7.84802 7.90152C7.00411 8.74543 6.53 9.89002 6.53 11.0835C6.53 12.277 7.00411 13.4216 7.84802 14.2655C8.69193 15.1094 9.83653 15.5835 11.03 15.5835Z" stroke="#FBBD05" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Support
          </p>
        </Col>
        <Col className="col-md-2">
          <p>
            <b>$0.00</b>
          </p>
        </Col>
      </Row>


      <Row>
        <Col className="col-md-10">
          <p className="checkout-item" >
            <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.625 9.01444L5.875 3.39194M1.2925 6.37111L10.75 11.8419L20.2075 6.37111M10.75 22.7511V11.8311M20.5 16.1644V7.49778C20.4996 7.11783 20.3993 6.74466 20.2092 6.4157C20.019 6.08675 19.7457 5.81359 19.4167 5.62361L11.8333 1.29028C11.504 1.10011 11.1303 1 10.75 1C10.3697 1 9.99604 1.10011 9.66667 1.29028L2.08333 5.62361C1.75428 5.81359 1.48098 6.08675 1.29083 6.4157C1.10069 6.74466 1.00039 7.11783 1 7.49778V16.1644C1.00039 16.5444 1.10069 16.9176 1.29083 17.2465C1.48098 17.5755 1.75428 17.8486 2.08333 18.0386L9.66667 22.3719C9.99604 22.5621 10.3697 22.6622 10.75 22.6622C11.1303 22.6622 11.504 22.5621 11.8333 22.3719L19.4167 18.0386C19.7457 17.8486 20.019 17.5755 20.2092 17.2465C20.3993 16.9176 20.4996 16.5444 20.5 16.1644Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            {planDescription} Plan - Monthly Subscription</p>
        </Col>
        <Col className="col-md-2">
          <p>
            {totalSubscriptionDiscount > 0 && <><s>{formatCurrency(planPrice)}</s><br /><b>{formatCurrency(customSubscription)}</b></>}
            {totalSubscriptionDiscount == 0 && <b>{formatCurrency(planPrice)}</b>}
          </p>
        </Col>
      </Row>

      <Row>
        <Col className="col-md-10">
          <p>
            <b>Total Due Today</b>
          </p>
        </Col>
        <Col className="col-md-2">
          <p>
            {(totalSubscriptionDiscount > 0 || totalSetupDiscount > 0) && <><s>{formatCurrency(totalPrice)}</s><br /><b>{formatCurrency(totalPrice - totalSetupDiscount - totalSubscriptionDiscount)}</b></>}
            {(totalSubscriptionDiscount == 0 && totalSetupDiscount == 0) && <b>{formatCurrency(totalPrice)}</b>}
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="col-md-12">
          <p className="disclaimer">The one time fee is paid only upon registration, on your second month we will only charge the monthly subscription fee. </p>
        </Col>
      </Row>
    </div>
  );
};
export default CheckoutReview;
